import ExpandButton from '@dustin-web/microsite-components/src/expand-button'
import { ProductCardGallery } from '@dustin-web/product-components/src/cards'
import { DigitalDataOrigin } from '@dustin-web/product-components/src/utils/digital-data-types'
import React, { useRef, useState } from 'react'
import { ProductReferenceListType, ProductReferenceType } from '../product-lists'

type Props = {
  productReferenceList: ProductReferenceListType
  title: string
  showMoreText: string
  showLessText: string
  showMoreQuery: {
    getMore: () => void
    moreProductReferences?: ProductReferenceType[]
    loadingMore: boolean
  }
  digitalDataOrigin: DigitalDataOrigin
}

const ProductPanel = ({
  productReferenceList,
  title,
  showMoreText,
  showLessText,
  showMoreQuery,
  digitalDataOrigin,
}: Props) => {
  const [showMore, setShowMore] = useState(false)
  const { getMore, moreProductReferences, loadingMore } = showMoreQuery
  const panelRef = useRef(null)
  if (productReferenceList.productReferences.length === 0) {
    return null
  }

  const handleShowMoreClick = (showMore: boolean) => {
    if (!showMore) {
      getMore()
      setShowMore(true)
    } else {
      const panel = panelRef.current as any as HTMLElement
      const headerY = document.querySelector('header')?.clientHeight || 0

      window.scrollBy({
        behavior: 'smooth',
        top: panel.getBoundingClientRect().y - headerY,
      })

      setTimeout(() => {
        setShowMore(false)
      }, 500)
    }
  }

  return (
    <>
      <div ref={panelRef} className="container u-pt-32">
        <h2>{title}</h2>
        <div className="row sm-gutters">
          {productReferenceList.productReferences.map(
            (productReference, i) =>
              productReference.searchResultProduct && (
                <ProductCardGallery
                  key={`${productReference.ticket}-${i}`}
                  product={productReference.searchResultProduct}
                  ticket={productReference.ticket}
                  digitalDataOrigin={digitalDataOrigin}
                  digitalIndex={i}
                  hTag="h3"
                />
              )
          )}
        </div>
      </div>
      {productReferenceList.productHits > 4 && (
        <div className="container u-mb-16">
          <div
            id={title}
            style={{
              maxHeight: !loadingMore && showMore ? '4000px' : 0,
              overflow: 'hidden',
              transition: !loadingMore && showMore ? 'max-height 1.5s' : 'max-height 0.5s',
              transitionTimingFunction: 'ease-out',
            }}>
            <div className="row sm-gutters">
              {moreProductReferences?.map(
                (productReference, i) =>
                  productReference.searchResultProduct && (
                    <ProductCardGallery
                      key={`${productReference.ticket}-${i}`}
                      product={productReference.searchResultProduct}
                      ticket={productReference.ticket}
                      digitalDataOrigin={digitalDataOrigin}
                      digitalIndex={i}
                      hTag="h3"
                    />
                  )
              )}
            </div>
          </div>
          <div>
            <ExpandButton
              collapsedTitle={showMoreText}
              expandedTitle={showLessText}
              expanded={showMore}
              onClick={() => handleShowMoreClick(showMore)}
              ariaControls={title}
            />
          </div>
        </div>
      )}
    </>
  )
}

export default ProductPanel
